export const DATA_REQUEST_STATUS_LIST = ['All Statuses', 'Pending', 'Processing', 'Completed', 'Failed', 'Cancelled'];
// UI labels for action filter. We keep backend values (Download/Delete) but show Export/Delete.
export const DATA_REQUEST_ACTION_LIST = ['All Actions', 'Export', 'Delete'];

export const DATA_REQUEST_STATUSES_MAPPING = {
    'Pending': {
        label: 'Pending',
        color: 'bg-[#fff5e6] text-[#ff9900]',
    },
    'Completed': {
        label: 'Completed',
        color: 'bg-[#d9f2dd] text-[#21bc68]',
    },
    'Failed': {
        label: 'Failed',
        color: 'bg-[#ffe4e4] text-[#ff0000]',
    },
    'Cancelled': {
        label: 'Cancelled',
        color: 'bg-[#ffe4e4] text-[#ff0000]',
    },
    'Processing': {
        label: 'Processing',
        color: 'bg-[#fcf7e6] text-[#e2b300]',
    },
    'Expired': {
        label: 'Expired',
        color: 'bg-[#ebbcca40] text-[#bc214f]',
    }
}